"use client"
import LocalizedClientLink from "@/components/molecules/LocalizedLink/LocalizedLink"
import { format } from "date-fns"
import { convertToLocale } from "@/lib/helpers/money"
import { ParcelAccordionItems } from "./ParcelAccordionItems"
import { useTranslate } from "@tolgee/react"
import { useState } from "react"
import { CollapseIcon } from "@/icons"
import { cn } from "@/lib/utils"

export const ParcelAccordion = ({
  orderId,
  orderDisplayId,
  createdAt,
  total,
  currency_code = "eur",
  orders,
}: {
  orderId: string
  orderDisplayId: string
  createdAt: string | Date
  total: number
  currency_code?: string
  orders: any[]
  defaultOpen?: boolean
}) => {
  const { t } = useTranslate()
  const [isOpen, setIsOpen] = useState(true)

  return (
    <div className="bb-order-card border border-[#e5e7eb] rounded-[10px] overflow-hidden mb-4">
      {/* 顶部灰色区域 - 订单汇总 */}
      <div className="bb-order-card-header bg-[#f9fafb] border-b border-[#e5e7eb] py-[12px] px-[20px] flex items-center justify-between">
        <div className="flex items-center gap-[32px]">
          <p className="bb-order-card-title text-[16px] font-semibold text-[#1e2939] leading-[24px]">
            {orderDisplayId}
          </p>
          <p className="bb-order-card-meta text-[14px] font-normal text-[#6a7282] leading-[20px]">
            {t("parcel_accordion.order_date")}: {format(new Date(createdAt), "yyyy-MM-dd")}
          </p>
          <p className="bb-order-card-meta text-[14px] font-normal text-[#6a7282] leading-[20px]">
            {t("parcel_accordion.total")}: {convertToLocale({ amount: total, currency_code })}
          </p>
        </div>
        <div className="flex items-center gap-[16px]">
          <LocalizedClientLink href={`/user/orders/${orderId}`}>
            <button className="bb-order-card-action border border-[#d1d5dc] rounded-[4px] px-[17px] py-[7px] text-[14px] font-medium text-[#4a5565] leading-[20px] hover:bg-gray-50">
              {t("parcel_accordion.view_order")}
            </button>
          </LocalizedClientLink>
          <p className="bb-order-card-meta text-[14px] font-normal text-[#6a7282] leading-[20px]">
            {orders.length} {t("common.items")}
          </p>
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="w-[16px] h-[16px] flex items-center justify-center"
          >
            <CollapseIcon
              size={16}
              className={cn(
                "transition-all duration-300",
                isOpen && "rotate-180"
              )}
            />
          </button>
        </div>
      </div>

      {/* 子订单列表 */}
      <div
        className={cn(
          "transition-all duration-300 overflow-hidden",
          isOpen ? "max-h-[10000px] opacity-100" : "max-h-0 opacity-0"
        )}
      >
        {orders.map((order, index) => (
          <ParcelAccordionItems
            key={order.id}
            order={order}
            index={index + 1}
            currency_code={currency_code}
            isLast={index === orders.length - 1}
          />
        ))}
      </div>
    </div>
  )
}
